/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */

import type { AuthenticationAction } from './actions.ts';
import { ActionType } from './actions.ts';
import type { AuthenticationState } from './state.ts';
import { authenticationInitialState } from './state.ts';

/**
 * Warning: this function MUST be fast, and we MUST clone state to return a new state object
 *
 */
export function authenticationReducer(state = authenticationInitialState, action: AuthenticationAction): AuthenticationState {
  switch (action.type) {
    case ActionType.Login: {
      const newState: AuthenticationState = { ...state };
      newState.tokenString = action.tokenString;
      newState.user = action.token.user;
      newState.userStatus = action.token.userStatus;
      return newState;
    }

    default:
      return state;
  }
}
